import { BusinessTagsFieldsFragment, TagType } from 'generated/graphql';
import { sortBy } from 'es-toolkit/compat';

interface TagByCategory<T> {
  type: T;
  measures: string[];
}

/**
 * For an array of business_tags (in the form BusinessTagsFieldsFragment), return an array of objects
 * that map each supplied meta_tag type to an array of meta_tag names
 */
export function getBusinessTagsByMetaTagType<T extends TagType>(
  data: BusinessTagsFieldsFragment[],
  types: T[]
): TagByCategory<T>[] {
  const measuresByCategoryDictionary = {} as { [category in TagType]: string[] };

  // We actually get tag datafrom the server in a somewhat arbitrary order.
  // For consistency of later display, sort the data by metaTag.id.
  for (const {
    metaTag: { type, name },
  } of sortBy(data, 'metaTag.id')) {
    let entry = measuresByCategoryDictionary[type];
    if (!entry) {
      entry = [];
      measuresByCategoryDictionary[type] = entry;
    }
    entry.push(name);
  }

  const measuresByCategory: TagByCategory<T>[] = [];

  for (const category of types) {
    if (measuresByCategoryDictionary[category]) {
      measuresByCategory.push({ type: category, measures: measuresByCategoryDictionary[category] });
    }
  }

  return measuresByCategory;
}
